import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GrupoService } from '../../../services/grupo.service';
import { EmpresaService } from '../../../services/empresa.service';
import { FacturacionService } from '../../../services/facturacion.service';
import { Facturacion } from '../../../models/facturacion';

@Component({
  selector: 'app-facturaciones',
  templateUrl: './facturaciones.component.html',
  styleUrls: ['./facturaciones.component.css'],
  providers: [GrupoService, EmpresaService, FacturacionService]
})
export class FacturacionesComponent implements OnInit {
  public status: string;
  public message_success: string;
  public message_error: string;
  public message_alert;
  public empresa;
  public empresas;
  public grupo_empresa_id: any = null;
  public token;
  public identity;
  public facturacion: Facturacion;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
    private _empresaService: EmpresaService,
    private _facturacionService: FacturacionService
  ) {
    this.identity = this._grupoService.getIdentity();
    this.token = this._grupoService.getToken();
    this.facturacion = new Facturacion(1, 1, '', '', '', '', '', '', '', '', '');
  }

  ngOnInit() {
    /*this._route.params.subscribe(params => {
        // convertir a entero
        let empresa_id = +params['empresa_id'];
    });*/
    this.getEmpresasByGrupo();
  }

  getEmpresasByGrupo() {
    this._empresaService.getEmpresasByGrupo(this.token).subscribe(
      response => {
        // Obtener el token 
        if (response.status == 'success') {
          this.empresas = response.empresas;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          this.empresas = null;
          this.message_error = error;
        }
      }
    );
  }

  getEmpresaId(event) {
    this.grupo_empresa_id = $("#grupo_empresa_id").val();
    this.getDatosFacturacion(this.grupo_empresa_id);
  }

  getDatosFacturacion(grupo_empresa_id) {
    this.facturacion = new Facturacion(1, grupo_empresa_id, '', '', '', '', '', '', '', '', '');

    this._facturacionService.getDatosDeFacturacion(this.token, grupo_empresa_id).subscribe(
      response => {
        // Obtener el token 
        if (response.status == 'success') {
          this.facturacion = response.datosFacturacion;
          this.facturacion = new Facturacion(
            1, this.facturacion['grupo_empresa_id'], this.facturacion['razon_social'], this.facturacion['rfc'],
            this.facturacion['direccion'], this.facturacion['no_interior'], this.facturacion['no_exterior'],
            this.facturacion['cp'], this.facturacion['colonia'], this.facturacion['ciudad'], 'PUT'
          )
        } else {
          $(".sin_datos").show();

          this.status = 'alert';
          this.message_alert = response.message;

          setTimeout(function () {
            $(".sin_datos").fadeTo(500, 1).slideUp(500, function () {
              $(".sin_datos").hide();
            });
          }, 3000);

          this.facturacion = new Facturacion(1, grupo_empresa_id, '', '', '', '', '', '', '', '', 'POST');
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          this.empresas = null;
          this.message_error = error;
        }
      }
    );
  }

  sendFacturacion(form) {
    console.log(this.facturacion)
    if (this.facturacion['method']) {
      if (this.facturacion['method'] == "POST") {
        $(".facturacion").show();
        this._facturacionService.createFacturacion(this.token, this.facturacion).subscribe(
          response => {
            // Obtener el token 
            if (response.status == 'success') {
              this.status = response.status;
              this.message_success = response.message;
              this.facturacion = new Facturacion(
                1, this.facturacion['grupo_empresa_id'], this.facturacion['razon_social'], this.facturacion['rfc'],
                this.facturacion['direccion'], this.facturacion['no_interior'], this.facturacion['no_exterior'],
                this.facturacion['cp'], this.facturacion['colonia'], this.facturacion['ciudad'], 'PUT'
              )
              setTimeout(function () {
                $(".facturacion").fadeTo(500, 1).slideUp(500, function () {
                  $(".facturacion").hide();
                });
              }, 3000);

            } else {
              this.status = response.status;
              this.message_error = response.message;

              setTimeout(function () {
                $(".facturacion").fadeTo(500, 1).slideUp(500, function () {
                  $(".facturacion").hide();
                });
              }, 3000);

            }
          },
          error => {
            if (error['status'] == 401) {
              this._router.navigate(['logout/1']);
            } else {
              this.empresas = null;
              this.message_error = error;
            }
          }
        );
      } else {
        $(".facturacion").show();
        this._facturacionService.update(this.token, this.facturacion['id'], this.facturacion).subscribe(
          response => {
            // Obtener el token 
            if (response.status == 'success') {
              this.status = 'success';
              this.message_success = response.message;

              setTimeout(function () {
                $(".facturacion").fadeTo(500, 1).slideUp(500, function () {
                  $(".facturacion").hide();
                });
              }, 3000);

            } else {
              this.status = 'error';
              this.message_error = response.message;

              setTimeout(function () {
                $(".facturacion").fadeTo(500, 1).slideUp(500, function () {
                  $(".facturacion").hide();
                });
              }, 3000);

            }
          },
          error => {
            if (error['status'] == 401) {
              this._router.navigate(['logout/1']);
            } else {
              this.facturacion = null;
              this.message_error = error;
            }
          }
        );
      }
    } else {
      this.status = 'error';
      this.message_error = 'Favor de escoger una empresa';
    }
  }
}
